<template>
  <BasePageContainer>
    <div class="page__head admin-head fixed-top p-3">
      <h1 class="admin-head__heading">
        <router-link
          to="/settings/"
          class="admin-head__back">
          <span class="material-icons">
            arrow_back_ios
          </span>
        </router-link>
        グループ管理
      </h1>
    </div>
    <div class="page__body admin-content pt-5">
      <ul class="admin-group__list list-unstyled mt-3">
        <li
          v-for="department in departments"
          :key="department.id"
          class="admin-group__item p-3 mb-3"
          data-testid="group-item">
          <div class="d-flex align-items-center justify-content-between">
            <p>
              <span class="material-icons admin-group__icon mr-1">
                people
              </span>
              <span>
                {{ department.sortNo | prettySortNo }}
              </span>
              {{ department.name }}
            </p>
            <div class="admin-group__edit">
              <button
                class="admin-group__btn btn--circle"
                @click="onClickEdit(department.id)">
                <span class="admin-group__btn-icon material-icons">
                  edit
                </span>
              </button>
              <button
                class="admin-group__btn btn--circle ml-2"
                data-testid="delete-group-button"
                @click="onClickDelete(department.id)">
                <span class="admin-group__btn-icon material-icons">
                  delete
                </span>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="admin__add text-right">
      <router-link to="/admin/groups/add">
        <button class="admin__add-btn btn--circle-l btn-l-blue">
          <span class="admin__add-icon material-icons">
            add
          </span>
        </button>
      </router-link>
    </div>
  </BasePageContainer>
</template>

<script>

export default {
  data() {
    return {
      departments: null,
    }
  },
  async created() {
    await this.fetch()
  }
  ,
  methods: {
    async fetch() {
      this.$store.commit('startLoading')
      const departments = await this.$axios.get('/departments/?ordering=-sort_no')
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return
        })
      if (departments && departments.data && departments.data.results)
        this.departments = departments.data.results
      this.$store.commit('finishLoading')
    },
    onClickEdit(id) {
      this.$router.push(`/admin/groups/${id}/edit`)
    },
    async onClickDelete(id) {
      const department = this.departments.find(v=>v.id===id)
      if (!window.confirm(`グループ「${department.name}」を削除します。よろしいですか？`)) return

      const users = await this.$axios.get(`/accounts/manage_staff/?department__in=${department.id}`)
      if (!users || !users.data || users.data.count !== 0){
        alert(`グループ「${department.name}」に所属するユーザーが存在する為削除できません。グループ内のユーザーをすべて移動させてください。`)
        return
      }
      this.$store.commit('startLoading')
      await this.$axios.delete(`/departments/${department.id}/`)
        .then(()=>{
          this.$store.commit('notify/set', {message: 'グループを削除しました。'})
        })
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          this.$store.commit('finishLoading')
          return
        })
      await this.fetch()
      this.$store.commit('finishLoading')

    }
  }
}
</script>

<style lang="scss" scoped>
.admin{
  padding-bottom: calc(16px + constant(safe-area-inset-bottom));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  &__add{
    right: 16px;
    position: fixed;
    bottom: 0px;
    padding-bottom: calc(80px + constant(safe-area-inset-bottom));
    padding-bottom: calc(80px + env(safe-area-inset-bottom));
  }
  &__add-btn{
    box-shadow: 1px 2px 6px $grey05;
  }
  &__add-icon{//ボタン
    font-size: 30px;
    line-height: 54px;
    width: 30px;
  }
}

.admin-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.admin-group{
  &__icon{
    vertical-align: middle;
    display: inline-block;
  }
  &__item{
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;
  }
  
  &__btn{
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
       padding: auto;
       line-height: auto;
    }

  }
  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }
}

</style>